import React, { useEffect, useState } from "react";
import { fechaActual } from "../../../hooks/UseDate";
import {
  getTipoDocumentoDespachoQxFarmacia,  
  postQuirofanosFarmacia,
  postTablaPrincipalDespachosQxFarmacia,
} from "../../../services/FarmaciaRuta";
import Loading from "../../Loading";
import ModalListaPersonalEnfermeria from "./ModalListaPersonalEnfermeria";
import TablaDespachoQXFarmacia from "./TablaDespachoQXFarmacia";
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { UserTokenURL } from "../../../services/ApiHIS";


const DespachoQXFarmacia = () => {
  const [loading, setloading] = useState(false);
  const [dataQuirofanos, setdataQuirofanos] = useState([]);
  //const [bodegas, setbodegas] = useState([]);
  const [tipoDocumento, settipoDocumento] = useState([]);
  const [dataDespachos, setdataDespachos] = useState([]);
  const [modalOnListaPersonalEnfermeria, setmodalOnListaPersonalEnfermeria] = useState(false);
  const [errorFechaInicial, seterrorFechaInicial] = useState("");
  const [errorFechaFinal, seterrorFechaFinal] = useState("");
  const [validarEnfermeria, setvalidarEnfermeria] = useState("");
  const [actualizarDespachos, setactualizarDespachos]=useState([])
  const [dataEnfermeria, setdataEnfermeria] = useState({
    idEnfermeria: "",
    nombreEnfermeria: "",
  });

   //token
   let query = new URLSearchParams(useLocation().search);
   let tokenCons = JSON.parse(query.get('token'));
   let location = useLocation();
  useEffect(() => {
    // Google Analytics
    localStorage.setItem('tokenReact',tokenCons)
  }, [location]);

  const handleOnclickListaPersonalEnfermeria = () => {
    setmodalOnListaPersonalEnfermeria(true);
  };
  ///actualizar la tabla de despacho
  const actualizarTablaDespacho=(data)=>{
    setactualizarDespachos(data)
  }
  ////Data enfermero
  const passDataEnfermeria = (data) => {
    setdataEnfermeria(data);
    setvalidarEnfermeria("");
  };
  useEffect(() => {
    setloading(false);
    setvalidarEnfermeria("Debe registrar persona que recibe los medicamentos despachados" );
    //QUIROFANOS
    const quirofanos = {
      EMPCOD: "1",
      ConsTpo: "QR",
      MCDpto: "001",
    };
    postQuirofanosFarmacia(quirofanos).then((res) => {
      setdataQuirofanos(res.data);
    });
    ///BODEGA
    // const bodega = {
    //   EMPCOD: "1",
    //   AUsrId: "HOSVITAL",
    //   BodDspPis: "S",
    //   MCDpto: "001",
    // };
    // postDespachoQxBodegaFarmacia(bodega).then((res) => {
    //   //console.log(res.data, "data bodegas");
    //   setbodegas(res.data);
    // });

    getTipoDocumentoDespachoQxFarmacia().then((res) => {
      //console.log(res.data, "tipo de documento");
      settipoDocumento(res.data);
    });
    //console.log('NOOO')
    
  }, []);

  useEffect(()=>{
    
    const despachos = {
      ProFec: `${fechaActual()}`,
      ProEmpCod: "1",
      ProSedQr: "001",
      PQEdoDes: "P",
      ProFecF: `${fechaActual()}`,
    };
    console.log(despachos,'despachos antes')
    postTablaPrincipalDespachosQxFarmacia(despachos).then((res) => {
      console.log(res.data, "despchos principal");
      setdataDespachos(res.data);
      setTimeout(() => {
        setloading(true);
      }, 2000);
    });
    //console.log('SIII')
  },[actualizarDespachos])

  const handleOnsubmitBuscar = (e) => {
    e.preventDefault();
    setloading(false);
    //console.log(e.target.estadosSelect.value,'ESTADOS')
    const despachos = {
      ProFec: e.target.fechaInicial.value,
      ProEmpCod: "1",
      ProSedQr: "001",
      PQEdoDes: e.target.estadosSelect.value,
      ProFecF: e.target.fechaFinal.value,
      MPCedu: e.target.numeroDocumento.value,
      MPNOMC: e.target.nombrePaciente.value,
      ProCons: e.target.quirofanoSelect.value,
    };
    if (errorFechaInicial === "" && errorFechaFinal === "") {
      //console.log(despachos, "despchos principal");
      postTablaPrincipalDespachosQxFarmacia(despachos).then((res) => {
        setdataDespachos(res.data);
        console.log(res.data,'data cancelada')
        setTimeout(() => {
          setloading(true);
        }, 3000);
      });
    }
  };
  const handleOnChangeFechaInicial = (e) => {
    //console.log(e.target.value);
    if (e.target.value) {
      seterrorFechaInicial("");
    } else {
      seterrorFechaInicial("Seleccionar fecha");
    }
  };
  const handleOnChangeFechaFinal = (e) => {
    //console.log(e.target.value);
    if (e.target.value) {
      seterrorFechaFinal("");
    } else {
      seterrorFechaFinal("Seleccionar fecha");
    }
  };

  //token
  useEffect(()=>{
    //console.log(tokenCons,'tokenConstokenCons')
    const url = UserTokenURL() 

    // Configurar la cabecera con el token JWT
    const headers = {
      Authorization: `Bearer ${tokenCons}`,
    };

    // Realiza la petición con Axios
    axios.get(url, { headers })
    .then(response => {
      //console.log(response.data.user_data, 'data user');

      // Si decides actualizar el localStorage, primero elimina los datos antiguos si es necesario
      localStorage.removeItem('usuarioInfo');
      console.log(localStorage.getItem('usuarioInfo'), 'antes data user')
      // Guarda los nuevos datos
      localStorage.setItem('usuarioInfo', JSON.stringify(response.data.user_data));

      //console.log(localStorage.getItem('usuarioInfo'),'antessss')
      // Comprobación de los datos almacenados
      const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
      console.log(usuarioInfo.tipoUsuario, 'usuarioInfoStr despachos')

      // Resto del código...
    })
    .catch(error => {
      console.error('Error al autenticar al usuario:', error);
      //seterrorEndpoint(true)
    });
  },[])
  return (
    <>
      <div className="">
        <div className=" text-2xl text-[#9e56fe]  font-medium pb-3">
          Despachos de Cirugía
        </div>
        <div className="text-center bg-[#9e56fe] pb-1">
          <label
            htmlFor="exampleFormControlInput1"
            className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
          >
            Seleccionar Persona Que Recibe
          </label>
        </div>

        <form onSubmit={handleOnsubmitBuscar}>
          <div className="flex flex-row py-1  text-left">
            <div className="w-1/3  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Recibe
              </label>
              <input
                onClick={handleOnclickListaPersonalEnfermeria}
                defaultValue={dataEnfermeria.idEnfermeria}
                autoComplete="off"
                name="cedulaPaciente"
                type="text"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
              <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                {validarEnfermeria}
              </label>
            </div>
            <div className="w-1/3  px-1 pt-2">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium "></label>
              <input
                //disabled={true}
                //defaultValue={dataUser.MPTDoc}
                defaultValue={dataEnfermeria.nombreEnfermeria}
                disabled={true}
                type="text"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
          </div>
          <div className="text-center bg-[#9e56fe] pb-1">
            <label
              htmlFor="exampleFormControlInput1"
              className="form-label inline-block mt-1 text-white font-medium px-1 text-xl "
            >
              Filtros de Búsqueda
            </label>
          </div>
          <div className="flex flex-row py-1  text-left">
            <div className="w-1/3  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Número Documento
              </label>
              <input
                //disabled={true}
                //defaultValue={nameUser.MPNOMC}
                autoComplete="off"
                name="numeroDocumento"
                type="text"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
            <div className="w-1/3  px-1 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Tipo Documento
              </label>

              <select
                //disabled={true}
                name="documentoSelect"
                className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                aria-label="Default select example"
              >
                {tipoDocumento.map((item) => (
                  <option value={item.MPTDoc} key={item.MPTDoc}>
                    {item.MPTDoc}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-1/3  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Nombre
              </label>
              <input
                //disabled={true}
                //defaultValue={nameUser.MPNOMC}
                autoComplete="off"
                name="nombrePaciente"
                type="text"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
            </div>
          </div>
          <div className="flex flex-row py-1  text-left">
            <div className="w-1/4  px-1 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Sala
              </label>

              <select
                //disabled={true}
                name="quirofanoSelect"
                className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                aria-label="Default select example"
              >
                <option value=''>TODOS</option>
                {dataQuirofanos.map((item) => (
                  <option value={item.ConsCod} key={item.ConsCod}>
                    {item.ConsDet}
                  </option>
                ))}
              </select>
            </div>
            <div className="w-1/4  px-1 ">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium"
              >
                Estado
              </label>

              <select
                //disabled={true}
                name="estadosSelect"
                className="form-select block  w-full px-2 py-1  font-normal text-gray-700 bg-[#eaebec] bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none text-sm"
                aria-label="Default select example"
              >
                <option value="P">Pendiente</option>
                <option value="R">Despacho Parcial</option>
                <option value="D">Despachado</option>
                <option value="C">Cancelado</option>
              </select>
            </div>
            <div className="w-1/4  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Fecha Inicial
              </label>
              <input
                onChange={handleOnChangeFechaInicial}
                name="fechaInicial"
                defaultValue={fechaActual()}
                type="date"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
              <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                {errorFechaInicial}
              </label>
            </div>
            <div className="w-1/4  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Fecha Final
              </label>
              <input
                onChange={handleOnChangeFechaFinal}
                name="fechaFinal"
                defaultValue={fechaActual()}
                type="date"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
              <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                {errorFechaFinal}
              </label>
            </div>
          </div>
          <div className="flex flex-row py-1  text-left">
            {/* <div className="w-1/2  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Fecha Inicial
              </label>
              <input
                onChange={handleOnChangeFechaInicial}
                name="fechaInicial"
                defaultValue={fechaActual()}
                type="date"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
              <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                {errorFechaInicial}
              </label>
            </div> */}
            {/* <div className="w-1/2  px-1 ">
              <label className="form-label inline-block mb-2 text-gray-900 font-medium ">
                Fecha Final
              </label>
              <input
                onChange={handleOnChangeFechaFinal}
                name="fechaFinal"
                defaultValue={fechaActual()}
                type="date"
                className="form-control block w-full px-2 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                id="exampleFormControlInput1"
                placeholder=""
              />
              <label className="form-label inline-block mb-2 text-red-900 text-sm font-medium">
                {errorFechaFinal}
              </label>
            </div> */}
            <div className="">
              <button
                
                type="submit"
                className="inline-block px-4 py-1.5 bg-[#9e56fe] text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
              >
                Buscar
              </button>
            </div>
          </div>
        </form>

        <div className="flex flex-col">
          <div className="overflow-x-auto  ">
            <div className="py-4 inline-block min-w-full">
              <div className="overflow-hidden">
                <table className="min-w-full text-center bg-gray-200">
                  <thead className=" ">
                    <tr>
                      <th scope="col" className=""></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      ></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      ></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      ></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      ></th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        N°
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Doc
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Identificación
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Paciente
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Fecha Cirugía
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Paquete
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Descripción
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Cantidad
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-4 py-2"
                      >
                        Estado
                      </th>
                    </tr>
                  </thead>
                  {loading ? (
                    dataDespachos.map((item, index) => (
                      <TablaDespachoQXFarmacia
                        key={index}
                        item={item}
                        validarEnfermeria={validarEnfermeria}
                        dataEnfermeria={dataEnfermeria}
                        actualizarTablaDespacho={actualizarTablaDespacho}
                      />
                    ))
                  ) : (
                    <tbody>
                      <tr className="divide-y divide-slate-700">
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                          <Loading />
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tbody>
                  )}
                  
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalOnListaPersonalEnfermeria ? (
        <ModalListaPersonalEnfermeria
          setmodalOnListaPersonalEnfermeria={setmodalOnListaPersonalEnfermeria}
          passDataEnfermeria={passDataEnfermeria}
        />
      ) : null}
    </>
  );
};

export default DespachoQXFarmacia;
